import { render, staticRenderFns } from "./QuesPy.vue?vue&type=template&id=7fd7f152&scoped=true&"
import script from "./QuesPy.vue?vue&type=script&lang=ts&"
export * from "./QuesPy.vue?vue&type=script&lang=ts&"
import style0 from "./QuesPy.vue?vue&type=style&index=0&id=7fd7f152&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@rakete/cli-plugin-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd7f152",
  null
  
)

export default component.exports